import type React from 'react';

export type brandTypes = 'linkedin' | 'instagram' | 'facebook' | 'youtube' | 'tiktok' | 'xing';

const SocialmediaLogo: React.FC<{
  brand: brandTypes;
  width?: number;
  height?: number;
  className?: string;
}> = ({ brand, width, height, className = '' }) => {
  const logoSrc = `/assets/socialmedia/${brand}.png`;

  return (
    <img
      src={logoSrc}
      alt={`${brand} Logo`}
      width={width}
      height={height}
      className={className}
      loading="lazy"
      decoding="async"
    />
  );
};

export default SocialmediaLogo;
